
import { inputsDefs, inputErrors } from "/opt/build/repo/node_modules/@mechanic-design/core/app/INPUTS";
import * as designFunction from "/opt/build/repo/functions/posterGenerator/index.js";
import { setUp } from "/opt/build/repo/node_modules/@mechanic-design/core/src/function-set-up.js";
setUp(inputsDefs, designFunction, inputErrors)
if (module.hot) {
  // Accept hot update
  module.hot.accept();
}